import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserEmail, getUserRole, logout } from '../services/authService';
import '../styles/App.css';

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const email = getUserEmail();
  const role = getUserRole();

  const handleLogout = () => {
    logout();
    localStorage.clear();
    window.location.reload();
  };

  const goToUserManagement = () => {
    navigate('/users');
    setShowMenu(false);
  };

  const goToDashboard = () => {
    navigate('/dashboard');
    setShowMenu(false);
  };

  return (
    <header className="header">
      <div className="header-left">
        <h1 className="logo" style={{ cursor: 'pointer' }} onClick={goToDashboard}>
          Brilliant Call
        </h1>
      </div>
      <div className="header-right">
        {role === 'admin' && (
          <button
            onClick={goToUserManagement}
            style={{
              padding: '6px 12px',
              backgroundColor: '#17a2b8',
              border: 'none',
              borderRadius: '4px',
              color: '#fff',
              fontSize: '13px',
              cursor: 'pointer',
              marginRight: '12px'
            }}
          >
            User Management
          </button>
        )}
        <span className="user-email">{email}</span>
        <div
          className="user-avatar"
          onClick={() => setShowMenu(!showMenu)}
          style={{ cursor: 'pointer', position: 'relative' }}
        >
          {email?.charAt(0).toUpperCase()}
          
          {showMenu && (
            <div
              style={{
                position: 'absolute',
                top: '45px',
                right: '0',
                backgroundColor: '#fff',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                minWidth: '160px',
                zIndex: 1000
              }}
            >
              <div
                style={{
                  padding: '12px 16px',
                  borderBottom: '1px solid #e0e0e0',
                  fontSize: '12px',
                  color: '#666'
                }}
              >
                <div style={{ fontWeight: '500', color: '#333', marginBottom: '4px' }}>
                  {email}
                </div>
              </div>
              {
                role === 'admin' && 
                <div
                onClick={goToDashboard}
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  color: '#333',
                  borderBottom: '1px solid #f0f0f0'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Dashboard
              </div>
              }
              {role === 'admin' && (
                <div
                  onClick={goToUserManagement}
                  style={{
                    padding: '12px 16px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    color: '#333',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  User Management
                </div>
              )}
              <div
                onClick={handleLogout}
                style={{
                  padding: '12px 16px',
                  cursor: 'pointer',
                  fontSize: '13px',
                  color: '#dc3545'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;